module.exports = __webpack_public_path__ + "static/media/allgaier-drum-drier-s.cb91d4c2.webp";